<template>
    <section class="flex flex-col-reverse md:flex-row">
        <DataTable 
            :value="materials" 
            :loading="props.loading" 
            dataKey="id"
            :paginator="true" 
            :rows="10"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            responsiveLayout="stack" 
            breakpoint="960px"
            class="p-datatable-sm shadow-sm border border-iron rounded w-full"
        >
            <template #empty> Nenhum material exclusivo cadastrado. </template>
            
            <Column field="name" header="Nome" sortable class="font-semibold text-secondary" />
            
            <Column field="description" header="Descrição">
            <template #body="slotProps">
                <span class="text-sm text-gray-600 line-clamp-2">
                {{ slotProps.data.description || 'Sem descrição.' }}
                </span>
            </template>
            </Column>

            <Column field="group" header="Grupo">
            <template #body="slotProps">
                <span class="text-sm text-gray-600 line-clamp-2">
                    {{ translate(materialDictionary.getLabel(slotProps.data.status), 'ucfirst') }}
                </span>
            </template>
            </Column>

            <Column header="Arquivo (Acesso Sob Demanda)" class="text-center w-48">
            <template #body="slotProps">
                <Button 
                label="Download" 
                icon="pi pi-download" 
                class="p-button-outlined p-button-sm text-xs"
                :loading="downloadingIds.has(slotProps.data.id)"
                @click="$emit('download', slotProps.data)"
                />
            </template>
            </Column>
            
            <Column header="Ações" class="text-center w-32">
            <template #body="slotProps">
                <Button 
                icon="pi pi-pencil" 
                class="p-button-text p-button-secondary" 
                @click="$emit('edit', slotProps.data)" 
                />
                <Button 
                icon="pi pi-trash" 
                class="p-button-text p-button-danger" 
                @click="$emit('delete', slotProps.data)" 
                />
            </template>
            </Column>
        </DataTable>
  </section>
</template>

<script setup>
import { defineProps, defineEmits, ref, onMounted, watch } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import MaterialDictionary from '@/dictionary/MaterialDictionary';
import { translate } from '@/composables/translate';

const props = defineProps({
  value: {
    type: Array,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  downloadingIds: {
    type: Object,
    default: () => new Set()
  }
});

defineEmits(['download', 'edit', 'delete']);
const materials = ref([]);
const materialDictionary = new MaterialDictionary();

onMounted(() => {
    checkVisibility();
});
watch(() => props.value, () => {
    checkVisibility()
},
    { deep: true, immediate: true }
);

function checkVisibility() {
    materials.value = props.value || [];
}
</script>